import { NgOptimizedImage } from '@angular/common';
import { Component, effect, ViewContainerRef, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { leftSlideIn, rightSlideIn } from './animations';
import { FooterComponent } from './core/footer/footer.component';
import { TopBarComponent } from './core/top-bar/top-bar.component';
import { ModalService } from './modal/modal.service';
import { NotificationComponent } from './notification/notification.component';
import { environment } from '@env/environment';
import { ChatFloatingSectionComponent } from '@features/chat/chat-floating-section/chat-floating-section.component';
import { ChatMessageTooltipComponent } from '@features/chat/chat-message-tooltip/chat-message-tooltip.component';
import { ChatComponent } from '@features/chat/chat.component';
import { NavigationTabBarComponent } from '@features/navigation/navigation-tab-bar/navigation-tab-bar.component';
import { NavigationTabBrowseComponent } from '@features/navigation/navigation-tab-browse/navigation-tab-browse.component';
import { NavigationTabGamesComponent } from '@features/navigation/navigation-tab-games/navigation-tab-games.component';
import { SessionService } from '@shared/session.service';
import { SocketService } from '@shared/socket.service';
import { UIService } from '@shared/ui.service';
import { UserActionsComponent } from '@shared/user-actions/user-actions.component';

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [leftSlideIn(150, '-100%'), rightSlideIn(150, '100%')],
  host: {
    '[class.chat-hidden]': 'isChatHidden()',
  },
  imports: [
    NgOptimizedImage,
    TopBarComponent,
    NavigationTabBarComponent,
    NavigationTabBrowseComponent,
    NavigationTabGamesComponent,
    UserActionsComponent,
    ChatMessageTooltipComponent,
    ChatComponent,
    NotificationComponent,
    RouterOutlet,
    FooterComponent,
    ChatFloatingSectionComponent,
  ],
})
export class AppComponent implements OnInit {
  splashScreen = true;
  cdnBase = environment.cdnBase;

  constructor(
    public uiService: UIService,
    public modalService: ModalService,
    public session: SessionService,
    viewContainerRef: ViewContainerRef,
    private socketService: SocketService,
    public router: Router,
  ) {
    this.modalService.setRootElement(viewContainerRef);

    effect(() => {
      if (this.socketService.connected()) {
        setTimeout(() => {
          this.splashScreen = false;
        }, 500);
      }
    });
  }

  ngOnInit() {
    this.uiService.width = window.innerWidth;

    setTimeout(() => {
      this.splashScreen = false;
    }, 3000);
  }

  isChatHidden() {
    return this.uiService.uiState().chat === 'hidden';
  }
}
